/**
 * @freesewing/plugin-cutonfold | v2.17.1
 * A FreeSewing plugin to add cut-on-fold indicators on your patterns
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var markers = `
<marker orient="auto" refY="0.0" refX="0.0" id="cutonfoldFrom" style="overflow:visible;" >
	<path class="note fill-note" d="M 0,0 L 12,-4 C 10,-2 10,2  12, 4 z" />
</marker>
<marker orient="auto" refY="0.0" refX="0.0" id="cutonfoldTo" style="overflow:visible;" >
	<path class="note fill-note" d="M 0,0 L -12,-4 C -10,-2 -10,2  -12, 4 z" />
</marker>
`;

var name = "@freesewing/plugin-cutonfold";
var version = "2.17.1";

var index = {
  name: name,
  version: version,
  hooks: {
    preRender: function (svg) {
      if (svg.attributes.get('freesewing:plugin-cutonfold') === false) {
        svg.attributes.set('freesewing:plugin-cutonfold', version);
        svg.defs += markers;
      }
    },
  },
  macros: {
    cutonfold: function (so) {
      if (so === false) {
        delete this.points.cutonfoldFrom;
        delete this.points.cutonfoldTo;
        delete this.points.cutonfoldVia1;
        delete this.points.cutonfoldVia2;
        delete this.paths.cutonfold;
        return true
      }
      let points = this.points;
      so = {
        offset: 15,
        margin: 5,
        prefix: '',
        ...so,
      };
      points['cutonfoldFrom' + so.prefix] = so.from.shiftFractionTowards(so.to, so.margin / 100);
      points['cutonfoldTo' + so.prefix] = so.to.shiftFractionTowards(so.from, so.margin / 100);
      points['cutonfoldVia1' + so.prefix] = points['cutonfoldFrom' + so.prefix]
        .shiftTowards(so.from, so.offset)
        .rotate(-90, points['cutonfoldFrom' + so.prefix]);
      points['cutonfoldVia2' + so.prefix] = points['cutonfoldTo' + so.prefix]
        .shiftTowards(so.to, so.offset)
        .rotate(90, points['cutonfoldTo' + so.prefix]);
      let text = so.grainline ? 'cutOnFoldAndGrainline' : 'cutOnFold';
      this.paths['cutonfold' + so.prefix] = new this.Path()
        .move(points['cutonfoldFrom' + so.prefix])
        .line(points['cutonfoldVia1' + so.prefix])
        .line(points['cutonfoldVia2' + so.prefix])
        .line(points['cutonfoldTo' + so.prefix])
        .attr('class', 'note')
        .attr('marker-start', 'url(#cutonfoldFrom)')
        .attr('marker-end', 'url(#cutonfoldTo)')
        .attr('data-text', text)
        .attr('data-text-class', 'center fill-note');
    },
  },
};

export default index;
//# sourceMappingURL=index.mjs.map
